import { api } from "./api";

/**
 * Client-side analytics: assigns a stable session ID and pings the backend
 * on every route change. Skips admin traffic and duplicates.
 */

const SESSION_KEY = "maklan_session";

function getSessionId() {
  let sid = localStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = "s_" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

let lastPath = "";

export async function trackVisit(path) {
  try {
    if (!path || path === lastPath) return;
    if (path.startsWith("/admin")) return;
    lastPath = path;
    await api.post("/analytics/visit", {
      path,
      session_id: getSessionId(),
      referrer: document.referrer || null,
      screen_w: window.screen?.width,
      screen_h: window.screen?.height,
    });
  } catch {
    /* swallow */
  }
}
